import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, redirectPath, clearRedirectPath } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  // Debug logging
  console.log('🔍 ProtectedRoute:', {
    hasUser: !!user,
    loading,
    redirectPath,
    currentPath: location.pathname
  });



  useEffect(() => {
    // Redirect if user is authenticated and has a redirect path
    if (user && redirectPath) {
      console.log('🔄 Redirecting to:', redirectPath);
      navigate(redirectPath, { replace: true });
      clearRedirectPath();
    }
  }, [user, redirectPath, navigate, clearRedirectPath]);

  if (loading) {
    // You can replace this with a proper loading component
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute; 